module.exports = __webpack_public_path__ + "static/media/present_christmas.2af82f31.svg";